import FileName from "../ComControl/FileName";
import MusicItem from "../ComControl/MusicItem";
import FontSetting from "../GameSystemData/FontSetting";
import { FileReader, FileWriter } from '@/platform'
import DataUtils from '../DataUtils'
import { normalizeRuntimeFontName, normalizeString, writeIntBool } from '../gameBinUtils'

class TotalSetting {
	public FontName: string = ""; //默认字体名称
	public FontSize: number = 30; //默认字体大小
	public IsTitle: boolean = false; //是否跳过标题画面
	public EnterSE: MusicItem = new MusicItem({
		name: new FileName({type: FileName.DEF_TYPE, name: 'click_1.mp3'}),
		volume: 80
	});//点击确定的音效
	public MoveSE: MusicItem = new MusicItem({
		name: new FileName({type: FileName.DEF_TYPE, name: 'move_1.mp3'}),
		volume: 80
	});//鼠标经过的音效
	public CancelSE: MusicItem = new MusicItem({name: new FileName({type: FileName.DEF_TYPE, name: 'error_1.mp3'}), volume: 80}); //取消的音效
	public WarningSE: MusicItem = new MusicItem({name: new FileName({type: FileName.DEF_TYPE, name: 'warning_1.mp3'}), volume: 80}); //错误音效
	public Ico: FileName = new FileName({type: FileName.DEF_TYPE, name: ''}); //游戏的图标
	public AuthorWords: string = ""; //作者的话
	public AuthorWordTime: number = 0; //作者的话出现的位置
	public Auto: boolean = false; //是否一开始便会开启自动播放功能 project_bin_no
	public StartMapId: number = 1; //剧情起始ID
	public FontColor_MSG: string = "222, 226, 241"; //对话默认颜色
	public FontColor_UI: string = "222, 226, 241"; //UI默认颜色
	public FontStyle: number = 0; //文字的效果
	public Init_savedata: boolean = true; //初始化存档
	public MenuIndex: number = 10001; //游戏菜单对应界面Index
	public MenuCodeSceneName: string = ''
	public OpenVit: boolean = false; //体力开关 project_bin_no
	public IsCloseCGBGM: boolean = false; // 是否关闭CGBGM project_bin_no
	/** cg_v3 为 number；低于 113 时文件里为 bool */
	public Show_ad: number = 1; // 广告是否展示
	public FontSettingList: FontSetting[] = [];
	public TestFlowers: number = 2000
	public IsSeniorStyle: number = 0
	public IsStroke: number = 0
	public StrokeColor: string = "0, 0, 0"
	public StrokeWidth: number = 1
	public IsShadow: number = 0
	public ShadowColor: string = "0, 0, 0"
	public ShadowWidth: number = 1

	public readBin(reader: FileReader): void {
		this.FontName = reader.readString()
		this.FontSize = reader.readInt()
		this.IsTitle = reader.readBool()
		this.EnterSE.readBin(reader)
		this.MoveSE.readBin(reader)
		this.CancelSE.readBin(reader)
		this.WarningSE.readBin(reader)
		this.Ico.readBin(reader)
		this.AuthorWords = reader.readString()
		this.AuthorWordTime = reader.readInt()
		this.Auto = reader.readBool()
		this.StartMapId = reader.readInt()
		this.FontColor_MSG = reader.readString()
		this.FontColor_UI = reader.readString()
		this.FontStyle = reader.readInt()
		this.Init_savedata = reader.readBool()
		this.MenuIndex = reader.readInt()
		this.MenuCodeSceneName = reader.readString()
		this.OpenVit = reader.readBool()
		this.IsCloseCGBGM = reader.readBool()
		this.Show_ad = reader.readInt()
		const fsLen = reader.readInt()
		this.FontSettingList = []
		for (let i = 0; i < fsLen; i++) {
			const fontSetting = new FontSetting()
			fontSetting.readBin(reader)
			this.FontSettingList.push(fontSetting)
		}
		if (DataUtils.dataVersion >= 112) {

			this.TestFlowers = reader.readInt()
		}
		if (DataUtils.dataVersion >= 115) {
			this.IsSeniorStyle = reader.readInt()
			this.IsStroke = reader.readInt()
			this.StrokeColor = reader.readString()
			this.StrokeWidth = reader.readInt()
			this.IsShadow = reader.readInt()
			this.ShadowColor = reader.readString()
			this.ShadowWidth = reader.readInt()
		}
	}

	public writeBin(writer: FileWriter): void {
		writer.writeString(this.FontName)
		writer.writeInt(this.FontSize)
		writer.writeBool(this.IsTitle)
		this.EnterSE.writeBin(writer)
		this.MoveSE.writeBin(writer)
		this.CancelSE.writeBin(writer)
		this.WarningSE.writeBin(writer)
		this.Ico.writeBin(writer)
		writer.writeString(this.AuthorWords)
		writer.writeInt(this.AuthorWordTime)
		writer.writeBool(this.Auto)
		writer.writeInt(this.StartMapId)
		writer.writeString(this.FontColor_MSG)
		writer.writeString(this.FontColor_UI)
		writer.writeInt(this.FontStyle)
		writer.writeBool(this.Init_savedata)
		writer.writeInt(this.MenuIndex)
		writer.writeString(this.MenuCodeSceneName)
		writer.writeBool(this.OpenVit)
		writer.writeBool(this.IsCloseCGBGM)
		writer.writeInt(this.Show_ad)
		writer.writeInt(this.FontSettingList.length)
		for (let i = 0; i < this.FontSettingList.length; i++) {
			this.FontSettingList[i]!.writeBin(writer)
		}
		if (DataUtils.dataVersion >= 112) {	
		writer.writeInt(this.TestFlowers)
		}
		if (DataUtils.dataVersion >= 115) {
			writer.writeInt(this.IsSeniorStyle)
			writer.writeInt(this.IsStroke)
			writer.writeString(this.StrokeColor)
			writer.writeInt(this.StrokeWidth)
			writer.writeInt(this.IsShadow)
			writer.writeString(this.ShadowColor)
			writer.writeInt(this.ShadowWidth)
		}
	}

	public writeGameBin(
		writer: FileWriter,
		options: {
			engineVersion: number
			runtimeFontName?: string
			isShowSystemMenu?: boolean
			section?: 'head' | 'tail'
		},
	): void {
		const section = options.section ?? 'head'
		if (section === 'tail') {
			writeIntBool(writer, this.Init_savedata)
			writer.writeInt(this.MenuIndex)
			if (options.engineVersion >= 109) {
				writer.writeString(normalizeString(this.MenuCodeSceneName))
			}
			return
		}

		writer.writeString(normalizeString(options.runtimeFontName || normalizeRuntimeFontName(this.FontName)))
		writer.writeInt(Number(this.FontSize || 0))
		writer.writeString(normalizeString(this.FontColor_MSG))
		writer.writeString(normalizeString(this.FontColor_UI))
		writer.writeInt(Number(this.FontStyle || 0))
		writeIntBool(writer, this.IsTitle)
		writer.writeInt(Number(this.StartMapId || 0))
		writer.writeInt(1)
		this.Ico.writeVersionedOui(writer)
		writer.writeInt(Number(this.Show_ad || 0))
		writer.writeString(normalizeString(this.AuthorWords))
		writer.writeInt(Number(this.AuthorWordTime || 0))
		writeIntBool(writer, this.Auto)
		writeIntBool(writer, options.isShowSystemMenu)
		this.EnterSE.writeVersionedOui(writer)
		this.MoveSE.writeVersionedOui(writer)
		this.CancelSE.writeVersionedOui(writer)
		this.WarningSE.writeVersionedOui(writer)

		if (options.engineVersion >= 110) {
			writer.writeInt(0)
			writer.writeInt(Number(this.IsStroke || 0))
			writer.writeString(normalizeString(this.StrokeColor))
			writer.writeInt(Number(this.StrokeWidth || 0))
			writer.writeInt(Number(this.IsShadow || 0))
			writer.writeString(normalizeString(this.ShadowColor))
			writer.writeInt(Number(this.ShadowWidth || 0))
		}
	}
}

export default TotalSetting

